export const URL = {
  base: import.meta.env.VITE_API_BASE_URL,
  // base: 'http://192.168.0.121:8000/api/',
  secretKey: import.meta.env.VITE_SECRETE_KEY,
};
